import {
  LayoutDashboard,
  Users,
  FileBarChart,
  ShieldCheck,
  Headphones,
  Coins,
  ScanFace,
  CandlestickChart,
  Wallet,
  MessagesSquare,
  Settings,
  Trophy,
  ShieldAlert,
  ClipboardList,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  label: string;
  to?: string;
  icon?: LucideIcon;
  badge?: string;
  children?: NavItem[];
}

/**
 * Admin sidebar — PROP-FIRM (AXProp).
 * Broker-only sections (deposits/withdrawals to balance, IB commission tree,
 * finance, fund transfer, bonuses, copy-trading, PAMM) are intentionally
 * removed for the funded-trader model. Prop modules whose pages aren't wired
 * yet fall through to ModuleStub via the App.tsx catch-all.
 */
export const adminNav: NavItem[] = [
  { label: "Dashboard", to: "/admin/dashboard", icon: LayoutDashboard },
  {
    label: "Challenges",
    icon: Trophy,
    children: [
      { label: "Challenge Plans", to: "/admin/challenges/plans" },
      { label: "Funded Accounts", to: "/admin/challenges/accounts" },
      { label: "Breaches & Events", to: "/admin/challenges/events" },
    ],
  },
  { label: "Payouts", to: "/admin/payouts", icon: Coins },
  { label: "Orders", to: "/admin/orders", icon: ClipboardList },
  {
    label: "Manage Client",
    icon: Users,
    children: [
      { label: "Client Admin", to: "/admin/manage-client/trader-admin" },
      { label: "Client Analysis", to: "/admin/manage-client/trader-analysis" },
    ],
  },
  {
    label: "Trading Accounts",
    icon: CandlestickChart,
    children: [
      { label: "Live Accounts", to: "/admin/accounts/live" },
      { label: "MT5 Connection", to: "/admin/mt5/connection" },
      { label: "Trading Report", to: "/admin/trade/report" },
    ],
  },
  {
    label: "Risk Desk",
    icon: ShieldAlert,
    children: [
      { label: "Risk Alerts", to: "/admin/risk" },
      { label: "Compliance", to: "/admin/compliance" },
    ],
  },
  {
    label: "KYC Management",
    icon: ScanFace,
    children: [
      { label: "KYC Settings", to: "/admin/kyc/settings" },
      { label: "KYC Request", to: "/admin/kyc/request" },
    ],
  },
  {
    label: "Reports",
    icon: FileBarChart,
    children: [
      { label: "Online Users", to: "/admin/reports/online-users" },
      { label: "Blocked Users", to: "/admin/reports/blocked-users" },
      { label: "Activity Log", to: "/admin/reports/activity-log" },
      { label: "Ledger Report", to: "/admin/reports/ledger" },
    ],
  },
  {
    label: "Manage Admin",
    icon: ShieldCheck,
    children: [
      { label: "Role Management", to: "/admin/admins/groups" },
      { label: "Admin List", to: "/admin/admins/list" },
      { label: "Module Control", to: "/admin/modules" },
    ],
  },
  {
    label: "Manager Settings",
    icon: Headphones,
    children: [
      { label: "Add Manager", to: "/admin/managers/add" },
      { label: "Manager List", to: "/admin/managers/list" },
    ],
  },
  { label: "Accounts Overview", to: "/admin/accounts/overview", icon: Wallet },
  { label: "Support Tickets", to: "/admin/support", icon: MessagesSquare },
  {
    label: "Settings",
    icon: Settings,
    children: [
      { label: "Company Setup", to: "/admin/settings?tab=company" },
      { label: "Branding & Logo", to: "/admin/settings?tab=branding" },
      { label: "Dashboard Theme", to: "/admin/settings?tab=dashboard" },
      { label: "Social Links", to: "/admin/settings?tab=social" },
      { label: "Footer Links", to: "/admin/settings?tab=footer" },
      { label: "SMTP Setup", to: "/admin/settings?tab=smtp" },
      { label: "Payment Gateway", to: "/admin/settings/payment-gateway" },
      { label: "Security Settings", to: "/admin/settings/security" },
      { label: "Client Settings", to: "/admin/settings/trader" },
      { label: "Email Templates", to: "/admin/email" },
    ],
  },
];
